/**
 * Optional profile image paths for team/board members.
 * Key: display name as in translations (e.g. "Jiahong (Jahong) Liu").
 */
export const teamMemberImages = {
  'Jiahong (Jahong) Liu': '/images/jiahong-liu.png',
  'Hadi Jaber': '/images/hadi-jaber.png',
  'Joseph Venanzio': '/images/joseph-venanzio.png',
  'Hassan Mahamat': '/images/hassan-mahamat.png',
  'Ben Zheng': '/images/ben-zheng.png',
  'Jiabei (Nicole) Liu': '/images/jiabei-nicole-liu.png',
  'Sean Galvan': '/images/sean-galvan.png',
  'Xuxin (Peter) Han': '/images/peter-han.png',
  'Xingdong (Sheldon) Li': '/images/sheldon-li.png',
  Mizo: '/images/mizo.png',
};

/** Optional object-position to show more above the head. Lower y% = more headroom. */
export const teamMemberImagePosition = {
  'Jiahong (Jahong) Liu': 'center 30%',
  'Joseph Venanzio': 'center 30%',
  'Jiabei (Nicole) Liu': 'center 25%',
  'Hadi Jaber': 'center 30%',
  'Xingdong (Sheldon) Li': 'center 25%',
  Mizo: 'center 40%',
};

/** Optional CSS transform to zoom in on a member's photo. */
export const teamMemberImageScale = {
  'Xingdong (Sheldon) Li': 'scale(1.35)',
  Mizo: 'scale(1.15)',
};

export const getMemberImage = (name) => teamMemberImages[name] || null;
export const getMemberImagePosition = (name) => teamMemberImagePosition[name] || 'center';
export const getMemberImageScale = (name) => teamMemberImageScale[name] || null;
